// Urban Brownies Constants

export const WHATSAPP_NUMBER = "+573107544509";
export const WHATSAPP_LINK = `https://wa.me/573107544509`;
export const INSTAGRAM_URL = "https://www.instagram.com/urbanbrownies1";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61563359609491";

// Product Images (Real photos from user)
export const PRODUCT_IMAGES = {
  cakeBirthday: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/t668nhig_1%20%282%29.png",
  boxesSorted: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/w3kfs7hv_1%20copy.png",
  cakeCaramel: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/3wptc94p_2.png",
  muffinArtistic: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/19d94n6e_Lucid_Origin_A_hyperrealistic_food_photography_shot_of_a_singl_1.jpg",
  browniesWithBow: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/lzjzi1bu_3%20copy.png",
  brownieIceCream: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/uttdb7ui_Lucid_Origin_A_gourmet_chocolate_brownie_muffin_served_on_a_wh_2%20%281%29.jpg",
  muffinsGrid: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/adc0lo67_Lucid_Origin_A_closeup_shot_of_six_homemadestyle_chocolate_muf_3.jpg",
  trayBrownies: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/kpo5jf0w_Flux_Dev_Ultrarealistic_food_photography_of_a_tray_of_artisana_3.jpg",
  brownieChips: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/sjdmjrtp_18.png",
  urbanCup: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/rprkcpae_15%20ENERO.png",
  urbanDecorated: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/k7v12f5c_brownie.jpeg",
  urbanCaramel: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/gax0lsy4_image.png",
  cakePersonal: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/n4167nsu_image.png",
  quizMorningCoffee: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/mijkwjjo_image.png",
  quizMixTextures: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/q491m6pi_image.png",
};

// Logo URLs
export const LOGO_URLS = {
  main: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/dq5d1d9y_LOGO%20BROWNIES%20.png",
  transparent: "https://customer-assets.emergentagent.com/job_brownie-quiz-store/artifacts/3ooof9nm_2-removebg-preview.png",
};

// Products Catalog
export const PRODUCTS = [
  {
    id: "urban-cup",
    name: "URBAN CUP",
    description: "Capas de brownie artesanal con toppings irresistibles en un vaso perfecto para cualquier antojo.",
    priceRange: "$18.000 - $22.000",
    basePrice: 18000,
    image: PRODUCT_IMAGES.urbanCup,
    tag: "Popular",
  },
  {
    id: "urban-bow",
    name: "URBAN WITH BOW",
    description: "Brownie individual envuelto con nuestro icónico lazo. El detalle perfecto para sorprender.",
    priceRange: "$8.500 - $9.000",
    basePrice: 8500,
    image: PRODUCT_IMAGES.browniesWithBow,
    tag: "Regalo",
  },
  {
    id: "urban-decorated",
    name: "URBAN DECORATED",
    description: "Brownies decorados a mano con chocolate blanco, perlas plateadas y mucho amor.",
    priceRange: "$4.500 - $7.500",
    basePrice: 4500,
    image: PRODUCT_IMAGES.urbanDecorated,
    tag: "Favorito",
  },
  {
    id: "urban-caramel",
    name: "URBAN WITH CARAMEL",
    description: "Brownie clásico bañado en dulce de arequipe casero. Una explosión de sabor colombiano.",
    priceRange: "$8.000",
    basePrice: 8000,
    image: PRODUCT_IMAGES.urbanCaramel,
    tag: "Bestseller",
  },
  {
    id: "urban-box-6",
    name: "URBAN BOX x6",
    description: "Caja con 6 brownies surtidos. Perfecta para compartir en familia o con amigos.",
    priceRange: "$47.000 - $51.000",
    basePrice: 47000,
    image: PRODUCT_IMAGES.muffinsGrid,
    tag: "Compartir",
  },
  {
    id: "cake-personal",
    name: "CAKE PERSONAL",
    description: "Mini torta de brownie de 360g. Tu momento dulce personal.",
    priceRange: "$30.000 - $35.000",
    basePrice: 30000,
    image: PRODUCT_IMAGES.cakePersonal,
    tag: "Nuevo",
  },
];

// Box Options for Builder
export const BOX_OPTIONS = [
  { id: "box-3", name: "Caja x3", quantity: 3, normalPrice: 26000, decoratedPrice: 29000 },
  { id: "box-4", name: "Caja x4", quantity: 4, normalPrice: 33000, decoratedPrice: 37000 },
  { id: "box-5", name: "Caja x5", quantity: 5, normalPrice: 40000, decoratedPrice: 44000 },
  { id: "box-6", name: "Caja x6", quantity: 6, normalPrice: 47000, decoratedPrice: 51000 },
  { id: "box-8", name: "Caja x8", quantity: 8, normalPrice: 61000, decoratedPrice: 66000 },
  { id: "box-12", name: "Caja x12", quantity: 12, normalPrice: 89000, decoratedPrice: 97000 },
];

// Brownie Types for Box Builder
export const BROWNIE_TYPES = [
  { id: "classic", name: "Clásico", price: 7500, image: PRODUCT_IMAGES.muffinArtistic },
  { id: "caramel", name: "Arequipe", price: 8000, image: PRODUCT_IMAGES.cakeCaramel },
  { id: "white-choco", name: "Choco Blanco", price: 7500, image: PRODUCT_IMAGES.boxesSorted },
  { id: "decorated", name: "Decorado", price: 9000, image: PRODUCT_IMAGES.browniesWithBow },
  { id: "chips", name: "Con Chips", price: 8000, image: PRODUCT_IMAGES.brownieChips },
  { id: "sugar", name: "Azúcar Glass", price: 7500, image: PRODUCT_IMAGES.muffinsGrid },
];

// Quiz Questions
export const QUIZ_QUESTIONS = [
  {
    id: 1,
    question: "¿Cómo describirías tu personalidad dulce?",
    options: [
      { id: "a", text: "Clásico y confiable", image: PRODUCT_IMAGES.muffinArtistic, value: "classic" },
      { id: "b", text: "Atrevido y diferente", image: PRODUCT_IMAGES.quizMixTextures, value: "bold" },
      { id: "c", text: "Dulce y cariñoso", image: PRODUCT_IMAGES.cakeCaramel, value: "sweet" },
      { id: "d", text: "Elegante y sofisticado", image: PRODUCT_IMAGES.browniesWithBow, value: "elegant" },
    ],
  },
  {
    id: 2,
    question: "Si tu brownie fuera un momento del día, ¿cuál sería?",
    options: [
      { id: "a", text: "Mañana tranquila con café", image: PRODUCT_IMAGES.quizMorningCoffee, value: "morning" },
      { id: "b", text: "Tarde de antojo inesperado", image: PRODUCT_IMAGES.urbanCup, value: "afternoon" },
      { id: "c", text: "Noche de película y manta", image: PRODUCT_IMAGES.trayBrownies, value: "night" },
      { id: "d", text: "Celebración especial", image: PRODUCT_IMAGES.cakeBirthday, value: "celebration" },
    ],
  },
  {
    id: 3,
    question: "¿Qué sabor te hace cerrar los ojos de placer?",
    options: [
      { id: "a", text: "Chocolate intenso puro", image: PRODUCT_IMAGES.muffinsGrid, value: "intense" },
      { id: "b", text: "Arequipe cremoso", image: PRODUCT_IMAGES.cakeCaramel, value: "caramel" },
      { id: "c", text: "Chocolate blanco suave", image: PRODUCT_IMAGES.urbanDecorated, value: "white" },
      { id: "d", text: "Mix de texturas", image: PRODUCT_IMAGES.quizMixTextures, value: "mix" },
    ],
  },
];

// Quiz Results
export const QUIZ_RESULTS = {
  classic: {
    brownie: "URBAN DECORATED Clásico",
    description: "Eres una persona que aprecia las cosas simples hechas con amor. Tu brownie ideal es nuestro clásico: textura perfecta, sabor auténtico, sin complicaciones.",
    image: PRODUCT_IMAGES.muffinArtistic,
    coupon: "CLASICO10",
    discount: "10%",
  },
  bold: {
    brownie: "URBAN WITH CHIPS",
    description: "Te gusta sorprender y ser sorprendido. Tu brownie tiene chips de chocolate extra porque la vida es más rica con texturas inesperadas.",
    image: PRODUCT_IMAGES.brownieChips,
    coupon: "ATREVIDO15",
    discount: "15%",
  },
  sweet: {
    brownie: "URBAN WITH CARAMEL",
    description: "Tienes un corazón dulce que ama consentir. El arequipe casero sobre nuestro brownie es tu abrazo en forma de postre.",
    image: PRODUCT_IMAGES.cakeCaramel,
    coupon: "DULCE10",
    discount: "10%",
  },
  elegant: {
    brownie: "URBAN WITH BOW",
    description: "Aprecias los detalles y la presentación impecable. Tu brownie viene envuelto con nuestro lazo signature porque mereces sentirte especial.",
    image: PRODUCT_IMAGES.browniesWithBow,
    coupon: "ELEGANTE20",
    discount: "20%",
  },
};

// Spin Wheel Prizes
export const WHEEL_PRIZES = [
  { id: 1, text: "10% OFF", color: "#C88037", textColor: "#fff" },
  { id: 2, text: "Brownie Extra", color: "#2D1810", textColor: "#fff" },
  { id: 3, text: "15% OFF", color: "#E5984A", textColor: "#fff" },
  { id: 4, text: "Envío Gratis", color: "#422418", textColor: "#fff" },
  { id: 5, text: "5% OFF", color: "#C88037", textColor: "#fff" },
  { id: 6, text: "Topping Extra", color: "#2D1810", textColor: "#fff" },
  { id: 7, text: "20% OFF", color: "#E5984A", textColor: "#fff" },
  { id: 8, text: "Mensaje Gratis", color: "#422418", textColor: "#fff" },
];

// Testimonials
export const TESTIMONIALS = [
  {
    id: 1,
    name: "María Fernanda",
    text: "Los mejores brownies que he probado en Bucaramanga. La textura es perfecta y el arequipe es divino. Ya soy clienta fija.",
    rating: 5,
    likes: 47,
    date: "Hace 2 semanas",
  },
  {
    id: 2,
    name: "Carlos Andrés",
    text: "Sorprendí a mi novia con una caja decorada y quedó encantada. La presentación es impecable y el sabor, espectacular.",
    rating: 5,
    likes: 32,
    date: "Hace 1 mes",
  },
  {
    id: 3,
    name: "Laura Valentina",
    text: "Pedí para el cumpleaños de mi mamá y fue un éxito total. Todos preguntaron de dónde eran. 100% recomendados.",
    rating: 5,
    likes: 56,
    date: "Hace 3 semanas",
  },
  {
    id: 4,
    name: "Juan Pablo",
    text: "El Urban Cup es adictivo. Perfecto para esos días que necesitas un gusto sin culpa... bueno, con poquita culpa.",
    rating: 5,
    likes: 28,
    date: "Hace 1 semana",
  },
];

// Poll Options
export const POLL_OPTIONS = [
  { id: "caramel", text: "Team Arequipe", emoji: "🍯" },
  { id: "chocolate", text: "Team Chocolate Puro", emoji: "🍫" },
  { id: "white", text: "Team Choco Blanco", emoji: "🤍" },
  { id: "mix", text: "Team Todos Juntos", emoji: "🎉" },
];

// Gift Occasions
export const GIFT_OCCASIONS = [
  "Cumpleaños",
  "Aniversario",
  "Agradecimiento",
  "Amor",
  "Amistad",
  "Perdón",
  "Felicitaciones",
  "Solo porque sí",
];

// Gift Extras
export const GIFT_EXTRAS = [
  { id: "vela", name: "Vela decorativa", price: 5000 },
  { id: "tarjeta", name: "Tarjeta impresa", price: 3000 },
];
